/* Optional "remember on this device": the built dataset (never the exports) in this browser's
 * IndexedDB. Off unless the runner ticks the box; one tap deletes it. Storage can be unavailable or
 * cleared by the browser at any time, so every call fails soft. */
import type { Dataset } from '../import/types';

const DB = 'mileposts', STORE = 'saved', KEY = 'dataset';

function open(): Promise<IDBDatabase> {
  return new Promise((resolve, reject) => {
    const req = indexedDB.open(DB, 1);
    req.onupgradeneeded = () => req.result.createObjectStore(STORE);
    req.onsuccess = () => resolve(req.result);
    req.onerror = () => reject(req.error);
  });
}

async function run<T>(mode: IDBTransactionMode, fn: (s: IDBObjectStore) => IDBRequest<T>): Promise<T> {
  const db = await open();
  try {
    return await new Promise<T>((resolve, reject) => {
      const req = fn(db.transaction(STORE, mode).objectStore(STORE));
      req.onsuccess = () => resolve(req.result);
      req.onerror = () => reject(req.error);
    });
  } finally { db.close(); }
}

export async function saveDataset(d: Dataset): Promise<boolean> {
  try { await run('readwrite', (s) => s.put(d, KEY)); return true; } catch { return false; }
}

export async function loadDataset(): Promise<Dataset | null> {
  try { return (await run<Dataset | undefined>('readonly', (s) => s.get(KEY))) ?? null; } catch { return null; }
}

/* Removes the saved dataset and every per-runner choice kept alongside it. */
export async function deleteSaved(): Promise<void> {
  try { await run('readwrite', (s) => s.delete(KEY)); } catch { /* nothing saved */ }
  try { Object.keys(localStorage).filter((k) => k.startsWith('mileposts.notRace.')).forEach((k) => localStorage.removeItem(k)); } catch { /* unavailable */ }
}
